/**
 * PartnerInfo Service
 * @class PartnerInfo
 * @property {string} id 파트너 조직 ID
 * @property {string} name 파트너 조직 이름
 * @property {boolean} partner 파트너 상태
 */
class PartnerInfo {
  constructor(props) {
    this.id = props.id
    this.name = props.name
    this.partner = props.partner
  }
}

/**
 * PartnerList Service
 * @class PartnerList
 * @property {array} list 파트너 조직 정보
 */
export class PartnerList {
  constructor(props) {
    this.list = props.map((obj) => new PartnerInfo(obj))
  }
}

export class OwnedPartnerOrg {
  constructor(props) {
    Object.assign(this, props)
  }
}

/**
 * UserInfo Service
 * @class UserInfo
 * @property {string} id 사용자 ID
 * @property {string} email 사용자 이메일
 * @property {string} name 사용자 이름
 * @property {string} phoneNumber 사용자 전화번호
 */
export class UserInfo {
  constructor(props) {
    this.id = props.id
    this.email = props.email
    this.name = props.name
    this.phoneNumber = props.phoneNumber
  }
}
